const appVersion =
  typeof __APP_VERSION__ === "string" && __APP_VERSION__
    ? __APP_VERSION__
    : "0.0.0";

const number =
  typeof __BUILD_NUMBER__ === "string" && __BUILD_NUMBER__ !== ""
    ? __BUILD_NUMBER__
    : "0";

const dateTime =
  typeof __BUILD_DATETIME__ === "string" && __BUILD_DATETIME__
    ? __BUILD_DATETIME__
    : "";

const version =
  typeof __BUILD_VERSION__ === "string" && __BUILD_VERSION__
    ? __BUILD_VERSION__
    : `${appVersion}+build.${number}${dateTime ? `.${dateTime}` : ""}`;

export const buildInfo = {
  appVersion,
  number,
  dateTime,
  version,
  label: version,
};
